export const SKIPPER_Q_LINK_NAME = 'q-link'

export const SKIPPER_VQ_LINK_NAME = 'vq-link'
export const SKIPPER_CQ_LINK_NAME = 'cq-link'
export const SKIPPER_CVQ_LINK_NAME = 'cvq-link'

export const SKIPPER_LINK_NAMES = [SKIPPER_VQ_LINK_NAME, SKIPPER_CQ_LINK_NAME, SKIPPER_CVQ_LINK_NAME] as const
